export enum NotificationPosition {
  BottomLeft,
  BottomRight,
  TopLeft,
  TopRight
}
